import {
  GLOBAL_COMMITMENT_2021_DATA_URL,
  GLOBAL_COMMITMENT_2021_REPORT_URL,
} from '../../variables';

export const mastheadTitle = 'Signatory reports';

export const openingParagraph = {
  content: {
    raw: `{"nodeType":"document","data":{},"content":[{"nodeType":"paragraph","content":[{"nodeType":"text","value":"The business and government signatories reporting through the Ellen MacArthur Foundation, along with key metrics provided for the 2021 Global Commitment reporting cycle, are displayed below.","marks":[],"data":{}}],"data":{}},{"nodeType":"paragraph","content":[{"nodeType":"text","value":"You can search for an organisation, sort, and filter the list, by using the features at the top of the table.","marks":[],"data":{}}],"data":{}},{"nodeType":"paragraph","content":[{"nodeType":"text","value":"To view a signatory’s full individual report, select the category it is part of (e.g. packaging producers and users) and click on the signatory’s name. ","marks":[],"data":{}}],"data":{}},{"nodeType":"paragraph","content":[{"nodeType":"text","value":"Business or government signatories that have not submitted their data for the 2021 Progress Report do not have an individual report page. ","marks":[],"data":{}}],"data":{}},{"nodeType":"paragraph","content":[{"nodeType":"text","value":"To understand the trends across the whole signatory group and per sector, see the ","marks":[],"data":{}},{"nodeType":"hyperlink","content":[{"nodeType":"text","value":"2021 Global Commitment Progress Report","marks":[],"data":{}}],"data":{"uri":"${GLOBAL_COMMITMENT_2021_REPORT_URL}"}},{"nodeType":"text","value":".","marks":[],"data":{}}],"data":{}},{"nodeType":"paragraph","content":[{"nodeType":"text","value":"Please note, this page is designed for desktop experience due to the amount of data involved.","marks":[],"data":{}}],"data":{}}]}`,
  },
};

export const categorySelectorTitle = '1. Choose a category';

export const listingTableTitle =
  '2. See organisations’ latest progress to achieve their 2025 targets';

export const listingTableSubtitle =
  'Click on an organisation’s name to see their individual report';

export const downloadLink = {
  text: 'Download all data',
  url: GLOBAL_COMMITMENT_2021_DATA_URL,
};

export const footerNote =
  '* Not aligned: in assessing the recyclability of their portfolio this signatory has departed from the New Plastics Economy 2021 recycling survey findings. This means that care should be taken when interpreting their recyclability percentage and comparing it with those of other signatories. For more information, see section on ‘100% reusable, recyclable or compostable’ when clicking on signatories’ individual reports.';

export const ppuData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
    {
      type: 'filter',
      id: 'sectorFilter',
      label: 'Sector',
      fields: ['sector'],
      checkboxData: [
        {
          type: 'all',
        },
        {
          type: 'header',
          id: 'Packaging producer',
          label: 'Packaging producers',
        },
        {
          type: 'standard',
          id: 'Packaging producer - Beverages',
          label: 'Beverages',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Packaging producer - Mixed',
          label: 'Mixed',
          isInset: true,
        },
        {
          type: 'header',
          id: 'Packaged goods company',
          label: 'Packaged goods companies',
        },
        {
          type: 'standard',
          id: 'Packaged goods company - Beverages',
          label: 'Beverages',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Packaged goods company - Cosmetics',
          label: 'Cosmetics',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Packaged goods company - Food',
          label: 'Food',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Packaged goods company - Household and personal care',
          label: 'Household and personal care',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Packaged goods company - Other',
          label: 'Other',
          isInset: true,
        },
        {
          type: 'header',
          id: 'Retailer',
          label: 'Retailers',
        },
        {
          type: 'standard',
          id: 'Retailer - Apparel, footwear and accessories',
          label: 'Apparel, footwear and accessories',
          isInset: true,
        },
        {
          type: 'standard',
          id: 'Retailer - Consumer staples',
          label: 'Consumer staples',
          isInset: true,
        },
      ],
    },
    {
      type: 'filter',
      id: 'reductionTargetFilter',
      label: 'Reduction Target',
      fields: ['reductionTargetType'],
      isExact: false,
      checkboxData: [
        {
          type: 'all',
        },
        {
          type: 'standard',
          id: 'Total',
          label: 'Total reduction',
        },
        {
          type: 'standard',
          id: 'Virgin',
          label: 'Virgin reduction',
        },
      ],
    },
    {
      type: 'sort',
      id: 'sortableNameSort',
      width: '24rem',
      matchDropdownWidth: false,
      radioInputData: [
        {
          label: 'Alphabetical (a to z)',
          fieldName: 'sortableName',
          isNumber: false,
          isAscending: true,
        },
        {
          label: 'Plastic packaging weight (high to low)',
          fieldName: 'plasticPackagingWeight',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Reusable (high to low)',
          fieldName: 'sortableReusablePlasticPackaging',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Reusable, recyclable or compostable (high to low)',
          fieldName: 'sortableRrcPlasticPackaging',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Post-consumer recycled content (high to low)',
          fieldName: 'sortablePcrContent',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Post-consumer recycled target (high to low)',
          fieldName: 'sortablePcrTarget',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Virgin reduction target (High to Low)',
          fieldName: 'reductionTargetRankVirgin',
          isNumber: true,
          isAscending: false,
        },
        {
          label: '% Total reduction target (High to Low)',
          fieldName: 'reductionTargetRankTotal',
          isNumber: true,
          isAscending: false,
        },
      ],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    { label: 'Plastic packaging weight (metric tonnes)' },
    { label: 'Reusable plastic packaging (%)' },
    {
      label: 'Reusable, recyclable or compostable plastic packaging (%)',
      width: '21%',
    },
    { label: 'Post-consumer recycled content (%)' },
    { label: 'Total and/or virgin plastic packaging reduction target' },
  ],
};

export const rmpncpData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    { label: 'Weight of plastic sold (metric tonnes)', width: '20%' },
    { label: 'Post-consumer recycled content (%)', width: '20%' },
  ],
};

export const rmpcpData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    { label: 'Weight of plastic sold (metric tonnes)', width: '20%' },
    {
      label: 'Renewable content from responsibly managed sources (%)',
      width: '20%',
    },
  ],
};

export const csrData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    {
      label: 'After-use activities',
      width: '20%',
    },
    {
      label: 'Plastic collected (metric tonnes)',
      width: '16%',
    },
    {
      label: 'Plastic sorted (metric tonnes)',
      width: '16%',
    },
    {
      label: 'Plastic recycled (outputs - metric tonnes)',
      width: '24%',
    },
  ],
};

export const sppiData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    { label: 'Description' },
  ],
};

export const govData = {
  dynamicFilterBlockData: [
    {
      type: 'search',
      title: 'search organisation',
      fields: ['name', 'sortableName'],
    },
  ],
  tableHeaderData: [
    {
      label: 'Organisation name',
      width: '20%',
    },
    { label: 'Government type', width: '20%' },
    {
      label: 'Country',
      width: '20%',
    },
  ],
};
